export enum EFullFeeType {
  monthlyFee,
  personalFee,
  dealerFee,
  nadaMonthlyFee,
  nadaBookOutFee,
  expressRecoveryFee,
  deficiencyTrackingFee,
  vrmFee,
  srsFee,
  reindeerFee,
}

export enum ENotFullFeeType {
  monthlyFee,
  personalFee,
  dealerFee,
  expressRecoveryFee,
  deficiencyTrackingFee,
  vrmFee,
  srsFee,
  reindeerFee,
}

export enum EInvoiceStatus {
  Unpaid,
  Paid,
}

export enum EPaymentStatus {
  Unpaid,
  Paid,
  Waived
}

export enum EFeeType {
  Unknown,
  Monthly,
  BidFee,
  AuctionFee, // Personal Administration Fee | Dealer Administration Fee
  NadaMonthlyFee,
  NadaBookOutFee,
  ExpressRecoveryMonthlyFee,
  DeficiencyTrackingFee,
  VrmFee,
  SrsFee,
  ReindeerFee,
}

export enum EFeeUserType {
  Other,
  PersonalId,
  DealerId
}

export enum EInvoicePage {
  Search         = 'search',
  Current        = 'current',
  OverThirtyDays = 'over-thirty-days',
  OverSixtyDays  = 'over-sixty-days',
  OverNinetyDays = 'over-ninety-days',
  InvoiceHistory = 'invoice-history',
  DefaultPricing = 'default-pricing',
  UseTax         = 'use-tax',
  CurrentDue     = 'current-due',
  PastDue        = 'past-due',
  Monthly        = 'monthly',
}

export enum EInvoiceProperty {
  Vin    = 'viNs',
  Number = 'InvoiceNumber',
}
